import React from 'react';
import { connect } from 'react-redux';

import { TableContainer } from 'apps/auth/components/common/components/TableRow/styles';
import { TableRow } from 'apps/auth/components/common/components/TableRow/TableRow';
import { DiskBadge } from 'apps/auth/components/common/DiskBadge/DiskBadge';
import { Row } from 'apps/auth/components/common/Layout/Row';
import { Separator } from 'apps/auth/components/common/Layout/Separator';
import { Panel } from 'apps/auth/components/common/Panel/Panel';
import { DiskBadgeWrapper } from 'apps/auth/components/common/Panel/styles';
import { Text } from 'apps/auth/components/common/Text/Text';
import { AUTH_BONUS_WITHDRAW } from 'apps/auth/constants/UrlConstants';
import { useAuth, useLanguage } from 'apps/auth/hooks/selectors';

const TopUpBonusCheque = (props) => {
    const { countryId } = useAuth();
    const { lang } = useLanguage();
    const cheque = props.cheque;

    const getAmount = (cheque) => {
        const toCurrency = cheque.amountToCurrency && typeof cheque.amountToCurrency === 'string' ? cheque.amountToCurrency.toLowerCase() : '';
        return (
            <Text size="header" ellipsis>
                {`${cheque.amountTo} `}
                <Text size="header" smallCaps>
                    {toCurrency}
                </Text>
            </Text>
        );
    };

    return (
        <>
            <Row indent="adaptive-16-24">
                <DiskBadge iconName="gift-48" variant="secondary" diskSize="large" />
            </Row>
            <Text variant="div" indent="4px" ellipsis>
                {props.chequeBonusLabel}
            </Text>
            <Row indent="64px">{getAmount(cheque)}</Row>
            {props.showWithdraw && (
                <>
                    <Separator marginTop="0" />
                    <Panel isHoverable type="reactLink" to={AUTH_BONUS_WITHDRAW} negativeMargin>
                        <DiskBadgeWrapper>
                            <DiskBadge variant="primary" iconName="arrow-right-dot" />
                        </DiskBadgeWrapper>
                        <Text color="primary">{props.withdrawTextPanel}</Text>
                    </Panel>
                </>
            )}
            <Separator marginTop={props.showWithdraw ? undefined : '0'} />
            <TableContainer>
                <TableRow title={props.chequeDate}>{props.getFormattedChequeDate(countryId, cheque.date, lang)}</TableRow>
            </TableContainer>
        </>
    );
};

const mapStateToProps = (state) => ({
    cheque: state.history.cheque.cheque,
    chequeDate: state.messages.pageMessages.chequeDate,
    chequeBonusLabel: state.messages.pageMessages.chequeBonusLabel,
    withdrawTextPanel: state.messages.pageMessages.withdrawTextPanel,
    showWithdraw: state.extra.showBonus,
});

export default connect(mapStateToProps)(TopUpBonusCheque);
